const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
const mediaScaleSpeed = 0.8;
const mediaShiftSpeed = 52;
const mediaParallaxSpeed = 1;
const scaleFreezeProgress = 0.38;

export const mainBannerAnimation = () => {
    const banners = document.querySelectorAll(".main-banner");

    if (!banners.length) {
        return;
    }

    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    // const mobileQuery = window.matchMedia("(max-width: 768px)");
    const bannerEntries = [];

    banners.forEach((banner) => {
        const wrapper = banner.querySelector(".main-banner__wrapper");

        if (!wrapper) {
            return;
        }

        const slideTargets = Array.from(
            banner.querySelectorAll(".main-banner__swiper-slide")
        ).filter((slide) => {
            const body = slide.querySelector(".main-banner__body");
            const media = slide.querySelector(".main-banner__content");

            return Boolean(body && media);
        });

        const fallbackBody = banner.querySelector(".main-banner__body");
        const fallbackMedia = banner.querySelector(".main-banner__content");
        const targets = slideTargets.length
            ? slideTargets
            : (fallbackBody && fallbackMedia ? [wrapper] : []);

        if (!targets.length) {
            return;
        }

        bannerEntries.push({wrapper, targets});
    });

    if (!bannerEntries.length) {
        return;
    }

    let rafId = null;

    const resetAnimation = () => {
        bannerEntries.forEach(({targets}) => {
            targets.forEach((target) => {
                target.style.removeProperty("--banner-body-shift");
                target.style.removeProperty("--banner-media-shift");
                target.style.removeProperty("--banner-media-scale");
            });
        });
    };

    const update = () => {
        rafId = null;

        if (motionQuery.matches) {
            resetAnimation();
            return;
        }

        bannerEntries.forEach(({wrapper, targets}) => {
            const rect = wrapper.getBoundingClientRect();
            const safeHeight = rect.height || 1;
            const scrollInside = clamp(-rect.top, 0, safeHeight);
            const progress = scrollInside / safeHeight;
            const bodyShift = Math.round(progress * -130);
            const frozenScale = 1 + (scaleFreezeProgress * mediaScaleSpeed);
            const frozenShift = scaleFreezeProgress * mediaShiftSpeed;
            const freezePoint = safeHeight * scaleFreezeProgress;

            let mediaShift = 0;
            let mediaScale = 1;

            if (scrollInside <= freezePoint) {
                const phaseProgress = freezePoint ? scrollInside / freezePoint : 0;

                mediaScale = 1 + (phaseProgress * (frozenScale - 1));
                mediaShift = phaseProgress * frozenShift;
            } else {
                mediaScale = frozenScale;
                mediaShift = frozenShift  + ((scrollInside - freezePoint) * mediaParallaxSpeed);
            }

            targets.forEach((target) => {
                target.style.setProperty("--banner-body-shift", `${bodyShift}px`);
                target.style.setProperty("--banner-media-shift", `${Math.round(mediaShift)}px`);
                target.style.setProperty("--banner-media-scale", mediaScale.toFixed(4));
            });
        });
    };

    const requestUpdate = () => {
        if (rafId !== null) {
            return;
        }

        rafId = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", requestUpdate, {passive: true});
    window.addEventListener("resize", requestUpdate);

    if (motionQuery.addEventListener) {
        motionQuery.addEventListener("change", requestUpdate);
    } else if (motionQuery.addListener) {
        motionQuery.addListener(requestUpdate);
    }

    // if (mobileQuery.addEventListener) {
    //     mobileQuery.addEventListener("change", requestUpdate);
    // } else if (mobileQuery.addListener) {
    //     mobileQuery.addListener(requestUpdate);
    // }

    update();
};
